import type { NextRequest } from "@/modules/fetch/types"

import { fetcher } from "@/modules/fetch/fetcher"

type UpdateOnboardingSeenParams = {
  hostname: string
  req?: NextRequest
}

export const updateOnboardingSeen = async ({ hostname, req }: UpdateOnboardingSeenParams): Promise<Response> => {
  const endpoint = "/api/student_profiles/v1/onboarding/seen"

  return fetcher(endpoint, {
    hostname,
    nextRequest: req,
    requestInit: {
      method: "POST",
    },
    serviceDomain: "MONOLITH_API",
  })
}
